import { sharedDesignTokens } from './desigh-tokens-shared';
import { primitive } from './primitives';

export const designTokens = {
  ...sharedDesignTokens,

  'background-active': primitive.plk.$popeyesOrange,
  'background-button-hover-reversed': primitive.$whiteOpacity10,
  'background-button-primary-default': primitive.plk.$burntOrange,
  'background-button-primary-default-reversed': primitive.$white,
  'background-button-primary-hover': primitive.plk.$burnOrangeDarken10,
  'background-button-secondary-hover': primitive.plk.$burntOrangeOpacity10,
  'background-checkbox-disabled': primitive.$blackOpacity30,
  'background-checked': primitive.plk.$nolaDark,
  'background-chip': primitive.plk.$nolaDark,
  'background-chip-rewards': primitive.plk.$nolaPurple,
  'background-chip-rewards-locked': primitive.plk.$nolaLight,
  'background-default': primitive.plk.$nolaLight,
  'background-dialog': primitive.$white,
  'background-error': primitive.$error,
  'background-focus': primitive.$blackOpacity4,
  'background-focus-reversed': primitive.$whiteOpacity4,
  'background-hero-light': primitive.$white,
  'background-hero-light-native': primitive.$white,
  'background-hero-reversed': `radial-gradient(50% 266.27% at 50% 50%, ${primitive.plk.$popeyesOrange} 0, ${primitive.plk.$burntOrange} 100%)`,
  'background-hero-reversed-native': primitive.plk.$popeyesOrange,
  'background-hero-bqq-brown': '',
  'background-hero-crunchy-green': '',
  'background-hero-fiery-red': '',
  'background-hero-flaming-orange': '',
  'background-hero-house-red': '',
  'background-hero-house-yellow': '',
  'background-hero-default': `radial-gradient(50% 140.08% at 50% 50%, ${primitive.plk.$popeyesOrange} 0, ${primitive.plk.$burntOrange} 100%)`,
  'background-hero-orange': `radial-gradient(50% 140.08% at 50% 50%, ${primitive.plk.$popeyesOrange} 0, ${primitive.plk.$burntOrange} 100%)`,
  'background-hero-purple': `linear-gradient(180deg, ${primitive.plk.$nolaPurple} 0, ${primitive.plk.$nolaPurpleDark} 96.4%)`,
  'background-icon-hover-focus': primitive.$blackOpacity4,
  'background-icon-hover-focus-reversed': primitive.$whiteOpacity4,
  'background-inline-alert': primitive.$blackOpacity4,
  'background-input': primitive.$white,
  'background-input-disabled': primitive.$blackOpacity4,
  'background-pattern': primitive.$white,
  'background-switch-thumb': primitive.$white,
  'background-switch-track': primitive.plk.$nolaDark,
  'background-switch-track-disabled': primitive.$blackOpacity30,
  'border-color-active': primitive.plk.$popeyesOrange,
  'border-color-button-secondary': primitive.plk.$burntOrange,
  'border-color-button-secondary-reversed': primitive.$white,
  'border-color-checked': primitive.plk.$nolaDark,
  'border-color-default': primitive.$blackOpacity10,
  'border-color-disabled': primitive.$blackOpacity30,
  'border-color-disabled-reversed': primitive.$whiteOpacity30,
  'border-color-error': primitive.$error,
  'border-color-hover': primitive.plk.$nolaDark,
  'icon-active': primitive.plk.$popeyesOrange,
  'icon-button-primary': primitive.$white,
  'icon-button-primary-reversed': primitive.plk.$nolaDark,
  'icon-button-reversed': primitive.$white,
  'icon-button-secondary': primitive.plk.$burntOrange,
  'icon-button-tertiary-default': primitive.plk.$nolaDark,
  'icon-button-tertiary-hover': primitive.plk.$burntOrange,
  'icon-default': primitive.plk.$nolaDark,
  'icon-disabled': primitive.$blackOpacity30,
  'icon-disabled-reversed': primitive.$whiteOpacity30,
  'icon-form-checkbox': primitive.$white,
  'icon-form-input-action': primitive.plk.$nolaDark,
  'icon-form-input-default': primitive.$blackOpacity30,
  'icon-reversed': primitive.$white,
  'icon-heart-favorite': primitive.plk.$spicyRed,
  'icon-heart-unfavorite': primitive.plk.$nolaDark,
  'padding-button-icon-end': `${primitive.$spacing0} ${primitive.$spacing2} ${primitive.$spacing0} ${primitive.$spacing4}`,
  'padding-button-icon-start': `${primitive.$spacing0} ${primitive.$spacing4} ${primitive.$spacing0} ${primitive.$spacing2}`,
  'padding-button-large': `${primitive.$spacing0} ${primitive.$spacing5}`,
  'padding-button-small': `${primitive.$spacing0} ${primitive.$spacing4}`,
  'padding-input': `${primitive.$spacing0} ${primitive.$spacing4}`,
  'text-active': primitive.plk.$burntOrange,
  'text-button-primary': primitive.$white,
  'text-button-primary-reversed': primitive.plk.$nolaDark,
  'text-button-reversed': primitive.$white,
  'text-button-secondary': primitive.plk.$burntOrange,
  'text-button-tertiary-default': primitive.plk.$nolaDark,
  'text-button-tertiary-hover': primitive.plk.$burntOrange,
  'text-default': primitive.plk.$nolaDark,
  'text-disabled': primitive.$disabledText,
  'text-disabled-reversed': primitive.$disabledTextReversed,
  'text-error': primitive.$error,
  'text-hero-light': primitive.plk.$nolaDark,
  'text-hero-reversed': primitive.$white,
  'text-link-default': primitive.plk.$nolaDark,
  'text-link-hover': primitive.plk.$burntOrange,
  'text-link-reversed': primitive.$white,
  'text-reversed': primitive.$white,
  'text-style-back-nav': 'var(--font-copyOne)',
  'text-style-bottom-nav': 'var(--font-copyTwo)',
  'text-style-button-large': 'var(--font-headerThree)',
  'text-style-button-small': primitive.plk.$headerFour,
  'text-style-card-copy': 'var(--font-copyTwo)',
  'text-style-card-header': 'var(--font-headerThree)',
  'text-style-chip': 'var(--font-copyTwo)',
  'text-style-chip-rewards': primitive.plk.$headerFour,
  'text-style-dialog-copy': 'var(--font-copyOne)',
  'text-style-dialog-header': 'var(--font-headerOne)',
  'text-style-form-checkbox': 'var(--font-copyOne)',
  'text-style-form-checkbox-header': 'var(--font-headerThree)',
  'text-style-form-hint': primitive.plk.$formUtility,
  'text-style-form-input': 'var(--font-copyOne)',
  'text-style-form-label-default': 'var(--font-copyOne)',
  'text-style-form-label-value': primitive.plk.$formUtility,
  'text-style-form-legend': 'var(--font-headerThree)',
  'text-style-form-options': primitive.plk.$formUtility,
  'text-style-hero-header': 'var(--font-hero)',
  'text-style-hero-subheader': 'var(--font-headerThree)',
  'text-style-hero-terms': 'var(--font-copyTwo)',
  'text-style-inline-alert': 'var(--font-copyTwo)',
  'text-style-item-description-copy': 'var(--font-copyTwo)',
  'text-style-item-description-header': 'var(--font-headerThree)',
  'text-style-list-item': 'var(--font-copyOne)',
  'text-style-list-item-info': 'var(--font-copyTwo)',
  'text-style-module': 'var(--font-headerOne)',
  'text-style-segment-header': 'var(--font-headerThree)',
  'text-style-tabs': 'var(--font-copyOne)',
  'text-style-top-nav': 'var(--font-copyOne)',
  'text-style-top-nav-right': primitive.plk.$headerFour,
  'text-tabs-default': primitive.plk.$nolaDark,
  'text-toggle-selected': primitive.$white,
  'transition-component': 'all .3s ease',
  'width-checkbox-radio': '20px',
  'width-icon': '24px',
  'width-icon-small': '16px',
  // Whitelabel-app-specific tokens to be added here, e.g.:
  // 'my-token-name': primitive.$black,
  'background-contrast-loyalty': primitive.plk.$popeyesOrange,
  'background-badge-cart-entry': primitive.$blackOpacity30,
  'background-icon-header-contrast': primitive.$blackOpacity4,
  'background-menu-customization-image': '',
  'border-default': `1px solid ${primitive.$blackOpacity10}`,
  'icon-header-contrast': primitive.plk.$nolaDark,
  'text-accent-order-number': primitive.plk.$nolaTeal,
  'text-loyalty-highlight': primitive.plk.$nolaPurple,
  'pickup-timed-fire-selector-button-background': primitive.$white,
  'padding-list-item-group-header': `${primitive.$spacing6} ${primitive.$spacing4} ${primitive.$spacing2}`,
  'margin-top-product-wizard-layout': '0',

  // Global App Colors
  'top-nav-bar-background-color': primitive.$white,
  'bottom-nav-bar-background-color': primitive.$white,
  'main-menu-carousel-background': primitive.$white,
  'bsm-default-background-color': primitive.plk.$nolaLight,
  'bsm-in-progress-background-color': primitive.$black,
  'bsm-drop-shadow': '0 0 3px rgb(0 0 0 / 10%)',
  'background-color': primitive.$white,
  'background-text-color': primitive.plk.$popeyesOrange,
  'background-border-radius': '800px',
  'background-border': `1px solid ${primitive.plk.$popeyesOrange}`,
};
